import styled from "styled-components";

const MessageParts = (props) => {
  const { parts = [], isNarrator = false } = props;
  return (
    <div className={'text_message'}>
      {parts.map((part, i) => {
        const { textType, text } = part; // speech, comment
        return (
          <div key={`i-${i}`} className={'part'} style={{ display: 'inline' }}>
            {textType === 'speech' && (
              <PartSpeech isNarrator={isNarrator} className={'part_speech_placeholder'}>
                {text}&nbsp;&nbsp;
              </PartSpeech>
            )}
            {textType === 'comment' && (
              <PartComment isNarrator={true} className={'part_comment_placeholder italic '}>
                {text}&nbsp;&nbsp;
              </PartComment>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MessageParts;

const PartComment = styled.div`
  display: inline;
  color: ${props =>
    props.isNarrator == true ? 'rgba(169, 169, 169, 1)' : 'rgba(255, 255, 255, 1)'};
  font-size: 16px;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const PartSpeech = styled.div`
  color: ${props =>
    props.isNarrator == true ? 'rgba(169, 169, 169, 1)' : 'rgba(255, 255, 255, 1)'};
  display: inline;
`;